// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"8d532ff6","215":"d7712c4e","435":"07dc2fbb","540":"9bcc0970","792":"8568f438","895":"7a4cf196"}[chunkId] + ".css";
};